import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// PAGES
import {
  Dashboard,
  Profile,
  MyClasses,
  MyClassesView,
  MyClassLive,
  ClassHistory,
  ClassHistoryView,
  Chat,
  Notifications,
  NotificationsView,
  MyWallet,
  Dispute,
  DisputeCreate,
  TransactionHistory,
  SalaryRequest,
  SalaryRequestCreate,
  LessonPlan,
  LessonPlanCreate,
  LeaveRequest,
  LeaveRequestCreate,
  LeaveRequestView,
  Assignment,
  AssignmentCreate,
  AssignmentView,
  SubmitedTask,
  SubmittedTaskView,
  SubmittedTaskCreateResult,
  Result,
  ResultView,
  ResultEdit,
  Attendance,
} from "./../../pages";
const TutorPanelRouterNavigation = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/tutor-panel/dashboard" element={<Dashboard />} />
        <Route path="/tutor-panel/profile" element={<Profile />} />
        <Route path="/tutor-panel/my-classes" element={<MyClasses />} />
        <Route
          path="/tutor-panel/my-classes/view"
          element={<MyClassesView />}
        />
        <Route path="/tutor-panel/my-classes/live" element={<MyClassLive />} />
        <Route path="/tutor-panel/class-history" element={<ClassHistory />} />
        <Route
          path="/tutor-panel/class-history/view"
          element={<ClassHistoryView />}
        />
        <Route path="/tutor-panel/chat" element={<Chat />} />
        <Route path="/tutor-panel/notifications" element={<Notifications />} />
        <Route
          path="/tutor-panel/notifications/view"
          element={<NotificationsView />}
        />
        <Route path="/tutor-panel/my-wallet" element={<MyWallet />} />
        <Route path="/tutor-panel/dispute" element={<Dispute />} />
        <Route path="/tutor-panel/dispute/create" element={<DisputeCreate />} />
        <Route
          path="/tutor-panel/transaction-history"
          element={<TransactionHistory />}
        />
        <Route path="/tutor-panel/salary-request" element={<SalaryRequest />} />
        <Route
          path="/tutor-panel/salary-request/create"
          element={<SalaryRequestCreate />}
        />
        <Route path="/tutor-panel/lesson-plan" element={<LessonPlan />} />
        <Route
          path="/tutor-panel/lesson-plan/create"
          element={<LessonPlanCreate />}
        />
        <Route path="/tutor-panel/leave-request" element={<LeaveRequest />} />
        <Route
          path="/tutor-panel/leave-request/create"
          element={<LeaveRequestCreate />}
        />
        <Route
          path="/tutor-panel/leave-request/view"
          element={<LeaveRequestView />}
        />
        <Route path="/tutor-panel/assignment" element={<Assignment />} />
        <Route
          path="/tutor-panel/assignment/create"
          element={<AssignmentCreate />}
        />
        <Route
          path="/tutor-panel/assignment/view"
          element={<AssignmentView />}
        />
        <Route path="/tutor-panel/submitted-task" element={<SubmitedTask />} />
        <Route
          path="/tutor-panel/submitted-task/view"
          element={<SubmittedTaskView />}
        />
        <Route
          path="/tutor-panel/submitted-task/create-result"
          element={<SubmittedTaskCreateResult />}
        />
        <Route path="/tutor-panel/result" element={<Result />} />
        <Route path="/tutor-panel/result/view" element={<ResultView />} />
        <Route path="/tutor-panel/result/edit" element={<ResultEdit />} />
        <Route path="/tutor-panel/attendance" element={<Attendance />} />
      </Routes>
    </BrowserRouter>
  );
};
export default TutorPanelRouterNavigation;
